const communities = [
  { name: "West Fargo", zip: "58078" },
  { name: "Moorhead, MN", zip: "56560" },
  { name: "Dilworth, MN", zip: "56529" },
  { name: "Horace", zip: "58047" },
  { name: "Harwood", zip: "58042" },
  { name: "Kindred", zip: "58051" },
  { name: "Casselton", zip: "58012" },
  { name: "Mapleton", zip: "58059" },
];

export default function LocalAreaSection() {
  return (
    <section id="service-area" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <div>
            <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-5">
              Serving Fargo and the Entire Red River Valley
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              Fast Passport Center serves all Fargo residents and surrounding Cass County communities. Our courier network covers the entire eastern North Dakota region — including the Minnesota border communities of Moorhead and Dilworth. No matter where you live in the Fargo metro, we can help you get your passport without a trip to a regional agency hundreds of miles away.
            </p>
            <div className="bg-white border border-gray-200 rounded-lg p-6 mb-6">
              <h3 className="font-bold text-[#1A365D] text-sm mb-3">Nearest Regional Passport Agency</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                The Chicago Passport Agency (230 S. Dearborn St) is approximately <strong className="text-[#1A365D]">570+ miles</strong> from Fargo. It requires an advance appointment and is only for genuine emergencies. For everyone else, Fast Passport Center handles agency submission remotely — no 10-hour round trip needed.
              </p>
            </div>
            <div className="flex flex-wrap gap-3">
              <div className="flex items-center gap-2 bg-white border border-gray-200 rounded-md px-3 py-2">
                <i className="ri-map-pin-line text-[#F6C344]"></i>
                <span className="text-sm text-[#1A365D] font-medium">Fargo, ND 58102</span>
              </div>
              <div className="flex items-center gap-2 bg-white border border-gray-200 rounded-md px-3 py-2">
                <i className="ri-map-pin-line text-[#F6C344]"></i>
                <span className="text-sm text-[#1A365D] font-medium">West Fargo, ND 58078</span>
              </div>
              <div className="flex items-center gap-2 bg-white border border-gray-200 rounded-md px-3 py-2">
                <i className="ri-map-pin-line text-[#F6C344]"></i>
                <span className="text-sm text-[#1A365D] font-medium">Moorhead, MN 56560</span>
              </div>
            </div>
          </div>
          <div>
            <h3 className="font-bold text-[#1A365D] text-base mb-4">Communities We Serve</h3>
            <div className="grid grid-cols-2 gap-3">
              {communities.map((c, i) => (
                <div key={i} className="bg-white border border-gray-200 rounded-md px-4 py-3 flex items-center justify-between">
                  <span className="text-sm font-medium text-[#1A365D]">{c.name}</span>
                  <span className="text-xs text-gray-400">{c.zip}</span>
                </div>
              ))}
            </div>
            <div className="mt-6 bg-[#1A365D] rounded-lg p-5">
              <h4 className="font-bold text-white text-sm mb-2">Hector International Airport (FAR)</h4>
              <p className="text-white/60 text-sm leading-relaxed">
                Fargo&apos;s primary airport handles direct flights to Chicago, Minneapolis, Denver, and Dallas. Having your passport ready for international connections is essential — Fast Passport Center ensures you never miss a flight due to expired or missing travel documents.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}